import React, { Component } from 'react';
import WorkoutsRenderActive from '../components/workout/workoutActive'
import { UserId, RequestInfoGet, serverUrl } from '../lib/funApp/general'
import { MDBIcon } from 'mdbreact';
import { Container, Row, Col, Card } from "react-bootstrap";

let targetUrl = serverUrl + '/src/workouts?user='+UserId

class WorkoutsGetActive extends Component {

  state = {
    workouts: [],
    links: {},
    loading: true,
    error: null
  }

  componentDidMount() {
    fetch(targetUrl ,RequestInfoGet)
    .then(res => res.json())
    .then((data) => {
      this.setState({ links: data._links })
      this.setState({ workouts: data.items })
      this.setState({ loading: false, error: null })
    })
    .catch((error) => {
      this.setState({ loading: false, error: error })
    })
  }

  renderStatus(message) {
    return (
      <>
        <Container>
          <Row className="TitleContainer">
            <Col style={{ padding: "10px"}}>
              <h4><MDBIcon icon="dumbbell" className="mr-2 ml-4" />Treino Ativo</h4>
            </Col>
          </Row>
        </Container>
        <Container className="MainContainer">
          <Row>
            <Col>
              <Card>
                <Card.Body className="text-center">{message}</Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }

  render() { 
    return (
      this.state.loading ? (
        this.renderStatus('Carregando...')
      ) : this.state.error ? (
        this.renderStatus('Erro ao carregar treinos.')
      ) : this.state.workouts[0] !== undefined ? (
        <WorkoutsRenderActive workouts={[this.state.workouts,this.state.links]} />
      ) : (
        this.renderStatus('Nenhum treino encontrado.')
      )
    )
  } 

}

export default WorkoutsGetActive;
